import Handlebars from "handlebars";

// Kebab-cases a string: "first_name" -> "first-name". Used to derive
// `data-testid` values from form-builder field names at render time.
Handlebars.registerHelper("dasherize", function (text) {
  return (text || "")
    .toString()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
});
